<template>
  <div class="faq-container">
    <div class="breadcrumb mb-20">
      <a href="/" class="breadcrumb-item">{{ $t('首页') }}</a>
      >
      <span>{{ $t('使用帮助') }}</span>
      >
      <span class="text-color-white">{{ selectQues?.title }}</span>
    </div>
    <div class="faq-content flex">
      <div class="faq-left mr-20 w-290 rounded bg-white px-20 py-30">
        <div class="faq-left-title">
          <div v-for="(item, index) in faqData" :key="index" class="faq-left-title-item mb-20" @click="selectQ(item)">
            <span class="faq-left-title-item-text cursor-pointer" :class="{ 'text-color-primary': item.title === selectQues.title }">{{
              item.title
            }}</span>
          </div>
        </div>
      </div>
      <div class="faq-right min-h-650 rounded bg-white" style="width: 1090px">
        <div class="faq-right-title border-b-[1px] border-[#EFF1F5] p-30">
          <div class="faq-right-title-item text-22" v-html="selectQues?.title"></div>
        </div>
        <div class="faq-right-content p-30" v-html="selectQues?.content"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getArtical } from '~~/api/steam'
const { data: faqData } = await getArtical({ type: 'faq' })

const selectQues = ref({})
const route = useRoute()
const router = useRouter()
if (route.query.q) {
  for (let i = 0; i < faqData.length; i++) {
    if (faqData[i].title == route.query.q) {
      selectQues.value = faqData[i]
    }
  }
}
if (!selectQues.value.content) {
  selectQues.value = faqData[0]
}
function selectQ(item) {
  selectQues.value = item
  router.push({
    path: '',
    query: {
      q: item.title
    }
  })
}
</script>

<style lang="scss" scoped>
.faq-container {
  margin-top: -230px;
  .breadcrumb {
    color: rgba(255, 255, 255, 0.5);
  }
}
</style>
